import { TIMESHEET_APPLICANT_STATUSES } from "./constants";

export const TIMESHEET_SEARCH_MIN_LENGTH = 3;

const normalizeTimesheetSearchQuery = (search) => {
  const raw = String(search || "").trim();
  if (!raw) {
    return { raw: "", userId: null };
  }

  const hashIdMatch = raw.match(/^#\s*(\d+)\s*$/);
  if (hashIdMatch) {
    return { raw, userId: hashIdMatch[1] };
  }

  const labeledIdMatch = raw.match(/^(?:user\s*)?id\s*[:#]?\s*(\d+)\s*$/i);
  if (labeledIdMatch) {
    return { raw, userId: labeledIdMatch[1] };
  }

  if (/^\d+$/.test(raw)) {
    return { raw, userId: raw };
  }

  const digitsOnly = raw.replace(/\D/g, "");
  if (
    digitsOnly.length >= TIMESHEET_SEARCH_MIN_LENGTH &&
    /\d/.test(raw) &&
    /\D/.test(raw)
  ) {
    return { raw, userId: digitsOnly };
  }

  return { raw, userId: null };
};

export const buildTimesheetStatusQueryParams = (statusFilter) => {
  const statusId = statusFilter?.id;

  if (!statusId) {
    return {};
  }

  return { event_request_status: statusId };
};

export const isCancelledEventRequestStatus = (status) =>
  status === TIMESHEET_APPLICANT_STATUSES.cancelled ||
  status === "auto_cancelled";

export const needsTimesheetClientStatusFilter = () => false;

export const filterTimesheetRowsByStatus = (rows, statusFilter) => {
  if (statusFilter?.id !== TIMESHEET_APPLICANT_STATUSES.cancelled) {
    return rows;
  }

  return rows.filter((row) =>
    isCancelledEventRequestStatus(row.event_request_status),
  );
};

export const buildTimesheetWorkingLogsSearchParams = (search) => {
  const { raw, userId } = normalizeTimesheetSearchQuery(search);
  if (!raw) {
    return {};
  }

  if (userId) {
    return { user_id: userId };
  }

  return { name: raw };
};

export const shouldSkipTimesheetSearchQuery = (search) => {
  const { raw, userId } = normalizeTimesheetSearchQuery(search);
  if (!raw) {
    return false;
  }

  if (userId) {
    return false;
  }

  return raw.length < TIMESHEET_SEARCH_MIN_LENGTH;
};

export const paginateRows = (rows, page, pageSize) => {
  const total = rows.length;
  const pages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const safePage = Math.min(Math.max(page, 1), pages);
  const startIndex = (safePage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  return {
    rows: rows.slice(startIndex, endIndex),
    total,
    pages,
    page: safePage,
    rangeFrom: total ? startIndex + 1 : 0,
    rangeTo: Math.min(endIndex, total),
  };
};

export const hasActiveTimesheetFilters = (search, filters) =>
  Boolean(search.trim()) ||
  Boolean(filters.role) ||
  Boolean(filters.status);

export const buildTimesheetNameOrderParams = (lang) => ({
  order_by_name_en: lang === "en" ? "asc" : undefined,
  order_by_name_ar: lang === "ar" ? "asc" : undefined,
});
